export const paymentRecievers = [
    { id: 'grp', groupBy: null, name: 'Groepskas', account: 'BE18 7360 3138 9365' },
    { id: 'kap', groupBy: 'Takken', name: 'Kapoenen', account: 'BE71 7360 3138 9769' },
    { id: 'wel', groupBy: 'Takken', name: 'Welpen', account: 'BE38 7360 3139 0072' },
    { id: 'wol', groupBy: 'Takken', name: 'Woudlopers', account: 'BE16 7360 3139 0274' },
    { id: 'jgv', groupBy: 'Takken', name: 'Jonggivers', account: 'BE91 7360 3139 0476' },
    { id: 'giv', groupBy: 'Takken', name: 'Givers', account: 'BE80 7360 3139 0577' },
    { id: 'kld', groupBy: null, name: 'Team kledij', account: 'BE47 7360 3139 0880' },
    { id: 'stm', groupBy: null, name: 'Stam HP', account: 'BE58 7360 3139 0779' },
];